export let UserExperience = /*#__PURE__*/function (UserExperience) {
  UserExperience["StudioClient"] = "StudioClient";
  UserExperience["StudioOwner"] = "StudioOwner";
  UserExperience["StudioMember"] = "StudioMember";
  UserExperience["Enterprise"] = "Enterprise";
  UserExperience["Partner"] = "Partner";
  UserExperience["Vista"] = "Vista";
  UserExperience["Dayful"] = "Dayful";
  UserExperience["Headless"] = "Headless";
  UserExperience["User"] = "User";
  UserExperience["Developer"] = "Developer";
  return UserExperience;
}({});
export let PriorityClass = /*#__PURE__*/function (PriorityClass) {
  PriorityClass["UNKNOWN"] = "UNKNOWN";
  PriorityClass["FIRST_CLASS"] = "FIRST_CLASS";
  PriorityClass["BUSINESS"] = "BUSINESS";
  PriorityClass["ECONOMY_PLUS"] = "ECONOMY_PLUS";
  PriorityClass["NOT_PRIORITY"] = "NOT_PRIORITY";
  return PriorityClass;
}({});
export let PartnerType = /*#__PURE__*/function (PartnerType) {
  PartnerType["UNKNOWN"] = "UNKNOWN";
  PartnerType["NOT_PARTNER"] = "NOT_PARTNER";
  PartnerType["HIGH_POTENTIAL"] = "HIGH_POTENTIAL";
  PartnerType["PARTNER_NOT_IN_PROGRAM"] = "PARTNER_NOT_IN_PROGRAM";
  PartnerType["PIONEER"] = "PIONEER";
  PartnerType["LEGEND"] = "LEGEND";
  PartnerType["CREATOR"] = "CREATOR";
  PartnerType["ICON"] = "ICON";
  PartnerType["EXPLORER"] = "EXPLORER";
  return PartnerType;
}({});
export let TopVertical = /*#__PURE__*/function (TopVertical) {
  TopVertical["UNKNOWN"] = "UNKNOWN";
  TopVertical["RESTAURANTS"] = "RESTAURANTS";
  TopVertical["STORES"] = "STORES";
  TopVertical["FITNESS"] = "FITNESS";
  TopVertical["BOOKINGS"] = "BOOKINGS";
  TopVertical["EVENTS"] = "EVENTS";
  return TopVertical;
}({});
//# sourceMappingURL=index.js.map